import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { RequestState, REQUEST_STATE } from "../../dataTypes";
import { fetchResourceCalendarSettings } from "../reducers/fetchResourceCalendarSettings";
import { selectRequestState } from "../resourceCalendarSettingsSelectors";

import { ResponseResourceCalendarSettings } from "../dataTypes";

let requestStateRef: RequestState | undefined;

const useFetchResourceCalendarSettings = () => {
  const dispatch = useAppDispatch();

  const requestState = useAppSelector(selectRequestState);

  if (requestStateRef === undefined) requestStateRef = requestState;

  useEffect(() => {
    requestStateRef = requestState;
  }, [requestState]);

  const loadResourceCalendarSettings = useCallback(async () => {
    if (requestStateRef !== REQUEST_STATE.PENDING) {
      requestStateRef = REQUEST_STATE.PENDING;

      const response = (await dispatch(fetchResourceCalendarSettings())).payload;

      let result: { isError: false; sessionId: string } | { isError: true };

      if (response) {
        const checkValidResSessionData: Partial<ResponseResourceCalendarSettings> =
          response as Partial<ResponseResourceCalendarSettings>;

        if (checkValidResSessionData.id) result = { isError: false, sessionId: checkValidResSessionData.id };
        else result = { isError: true };

        return result;
      }
    }
  }, [dispatch]);

  return loadResourceCalendarSettings;
};

export default useFetchResourceCalendarSettings;
